<template>
  <v-dialog v-model="show" :width="width" :persistent="pers">
    <!--<template v-slot:activator="{ on }">
        <v-btn
          color="primary"
       
          v-on="on"
        >
          <slot name="trigger-btn">Add</slot>
        </v-btn>
    </template>-->

    <v-card id="srptCard">
      <v-card-title class="headline grey lighten-2" primary-title>
        <slot name="modal-title">Title Here</slot>
        <v-spacer></v-spacer>
        <v-btn icon color="success" @click="print()">
          <v-icon>print</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text id="srpt">
        <slot name="modal-content">Content Here</slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <slot name="modal-actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
#srptCard .v-table thead th {
  white-space: normal !important;
}
</style>
<script>
export default {
  props: {
    width: {
      type: String,
      default: "500px"
    },
    show: {
      type: Boolean,
      default: false
    },
    pers:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      refresh_key: 0
    };
  },

  methods: {
    print() {
      //window.print();

      // Get HTML to print from element
      const prtHtml = document.getElementById("srpt").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1200,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.title = "Sales Report";
      WinPrint.document.write(toPrint);

      
      WinPrint.document.close();
      WinPrint.focus();
      if (WinPrint.document.readyState === "complete") {
        setTimeout(function() {

          WinPrint.print();
          WinPrint.close();
        }, 1300);
      }
    }
  }
};
</script>